document.addEventListener('DOMContentLoaded', function () {
    console.log('✅ cart-new.js loaded');

    const params = new URLSearchParams(window.location.search);
    const isInvoiceURL = params.get('invoice') === 'true';

    if (!isInvoiceURL) return;

    document.body.classList.add('invoice-mode');

    const observer = new MutationObserver(() => {
      let allDone = true;

      // ✅ Checkout button
      const btn = document.querySelector('button[name="checkout"].cart-submit-button');
      if (btn && !btn.dataset.invoiceStyled) {
        btn.dataset.invoiceStyled = "true";

        if (!btn.innerText.toLowerCase().includes('invoice')) {
          btn.innerText = 'Pay by Invoice';
        }

        btn.style.setProperty('background-color', '#87949a', 'important');
        btn.style.setProperty('border-color', '#87949a', 'important');
        btn.style.setProperty('color', '#ffffff', 'important');
        btn.style.setProperty('text-transform', 'none', 'important');
        btn.style.transition = 'background-color 0.2s ease, opacity 0.2s ease';

        btn.addEventListener('mouseenter', () => {
          btn.style.setProperty('background-color', '#87949a', 'important');
          btn.style.setProperty('border-color', '#87949a', 'important');
          btn.style.opacity = '0.9';
        });

        btn.addEventListener('mouseleave', () => {
          btn.style.setProperty('background-color', '#87949a', 'important');
          btn.style.setProperty('border-color', '#87949a', 'important');
          btn.style.opacity = '1';
        });
      } else if (!btn) {
        allDone = false;
      }

      // ✅ Continue Shopping button (TEXT IS OUTSIDE <a>)
      const continueBtn = document.querySelector('.cart-continue-button');
      if (continueBtn) {
        continueBtn.style.setProperty('text-transform', 'none', 'important');
      } else {
        allDone = false;
      }

      // ✅ Hide wallet buttons
      const walletWrapper = document.querySelector('.wallet-button-wrapper');
      if (walletWrapper) {
        walletWrapper.style.display = 'none';
      } else {
        allDone = false;
      }

      const quickCheckout = document.querySelector('#yy-quick-checkout');
      if (quickCheckout) {
        quickCheckout.style.display = 'none';
      } else {
        allDone = false;
      }

      if (allDone) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  window.addEventListener('load', function () {
      enforceLimitedVariant();
    document.addEventListener("keydown", function (e) {
      const qtyInput = e.target.closest('#qty-container #quantity');

      if (qtyInput && e.key === "Enter") {
        e.preventDefault();
        return false;
      }
    });
    document.querySelectorAll('#qty-container').forEach((qtyContainer) => {
      const qtyButtons = qtyContainer.querySelectorAll('input[type="button"]');
      const qtyInput = qtyContainer.querySelector("#quantity");
      const cartDataJson = document.getElementById("cart_data_json");
      let cartData = cartDataJson ? JSON.parse(cartDataJson.textContent) : null;
      let debounceTimer;

      if (!cartData || !cartData.items) return;

      // Manual typing is disabled on purpose — the field is a display value only.
      // Quantity changes must go through the +/- buttons so the accessory
      // group (delivery line, installation, etc.) is always updated in lockstep
      // with the parent item. Without this, a user could type "0" and click
      // Checkout before the debounce/network round-trip finished, removing the
      // parent but leaving its sub-items behind.
      qtyInput.addEventListener("keydown", (e) => e.preventDefault());
      qtyInput.addEventListener("paste", (e) => e.preventDefault());
      qtyInput.addEventListener("wheel", (e) => qtyInput.blur());
      qtyButtons.forEach((qtyBtn) => {
        qtyBtn.addEventListener("click", async function (e) {
          e.preventDefault();

          const currentQty = parseInt(qtyInput.value, 10) || 1;

          let newQty = this.classList.contains("qty_minus")
            ? currentQty - 1
            : currentQty + 1;

          // newQty = Math.min(9, Math.max(1, newQty));
          newQty = Math.max(1, newQty);

          updateCartQuantity(qtyInput, newQty);
        });
      });

      async function updateCartQuantity(qtyInput, newQty) {
        const key = qtyInput.getAttribute("data-id");
        if (!key) return;

        const pageLoader = document.getElementById("page_Loader");
        if (pageLoader) pageLoader.classList.add("open");

        try {
          const mainItem = cartData.items.find((item) => item.key === key);
          if (!mainItem) return;

          const accessoryGroupId = mainItem?.properties?._accessoryGroupId;

          const subItems = cartData.items.filter(
            (item) =>
              item.properties &&
              !item.properties._accessoryVariantIds &&
              item.properties._accessoryGroupId === accessoryGroupId,
          );

          const formData = new FormData();

          // LIMITED parent + LIMITED child (or delivery line):
          //   parent qty 1-3 -> child 1, parent qty > 3 -> child 2
          // Everything else follows the parent quantity.
          subItems.forEach((item) => {
            const qty = getAccessoryQuantity(
              mainItem.product_id,
              newQty,
              item.variant_id,
              isDeliveryLineName(item.variant_title || item.product_title)
            );
            formData.append(`updates[${item.key}]`, qty);
          });

          const mainQty = isLimitedVariant(mainItem.variant_id) ? 1 : newQty;
          formData.append(`updates[${mainItem.key}]`, mainQty);

          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
          });

          qtyInput.value = mainQty;
          mainItem.quantity = mainQty;

          if (accessoryGroupId) {
            await enforceOrderValueAfterQuantityChange(mainItem.key, accessoryGroupId);
          }

        } catch (err) {
          console.error("Quantity Update Error:", err);
        }
        window.location.href = "/cart";
      }
    });
  });


  /**
   * Removes a line item from the cart page.
   *
   * - If a MAIN product is removed, all of its accessory/sub items are removed too
   *   (same as cart-drawer.js).
   * - If a SUB item (accessory) is removed, it's just taken off the main item's
   *   accessory property lists.
   * - If the SUB item being removed is a DELIVERY OPTION (Free / Standard /
   *   4-week lead time / Order Value £15000+), a replacement delivery variant
   *   is automatically added back based on the main item's price + size/colour
   *   options — mirroring the logic in cart-drawer.js's remove handler, so
   *   cart page and cart drawer behave identically instead of the cart page
   *   ending up with no delivery option left after the last one is removed.
   * - If the SUB item being removed is a Custom Top accessory (Deluxe Ply Edge /
   *   Scallop Top / Wave Desktop) that was the reason the cart was bumped onto
   *   the 4-week lead time delivery, and the desk size/colour combo isn't
   *   independently restricted, the delivery line is also swapped back down to
   *   the normal default (Free/Standard) — see
   *   downgradeLeadTimeDeliveryIfNoLongerNeeded().
   * - Whatever sub item was removed, if the currently-selected delivery line
   *   is the "Order Value £15000 or above" card and the remaining order
   *   subtotal (accessories + quantity, excluding delivery) has dropped below
   *   £15000, that card is automatically swapped back to the normal default
   *   delivery too — see computeOrderValueDowngrade().
   */
  /**
   * GET AVAILABLE DELIVERY CARDS FOR A PRODUCT
   * Delivery cards are driven by a product metafield, so not every
   * product has every delivery option (e.g. some never get the 4-week
   * lead time card). This fetches the product's own page and reads
   * which .delivery-card elements actually exist for it, so we never
   * add a variant that was never offered on that product in the first
   * place. Same helper as in cart-drawer.js.
   */
  async function getAvailableDeliveryCards(handle) {
    if (!handle) return [];

    try {
      const res = await fetch(`/products/${handle}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      return [...doc.querySelectorAll(".delivery-card")]
        .map((card) => ({
          variantId: card.dataset.variantId,
          productId: card.dataset.productId,
          price: card.dataset.variantPrice,
          name: card.dataset.variantName,
        }))
        .filter((c) => c.variantId);
    } catch (err) {
      console.error("Failed to fetch delivery cards for product:", handle, err);
      return [];
    }
  }

  /* =====================================
    CUSTOM TOP LEAD-TIME ACCESSORY HELPERS
    Same rules as cart-drawer.js / yy_delivery_option-new.js, kept in
    sync here for the cart page.
  ===================================== */
  const CUSTOM_TOP_LEAD_TIME_BASE_NAMES = [
    "Deluxe Ply Edge",
    "Scallop Top",
    "Wave Desktop",
  ];

  const LEAD_TIME_ACCESSORIES = [
    "Deluxe Ply Edge",
    "2 X  Deluxe Ply Edge",
    "Scallop Top",
    "2 X Scallop Top",
    "2 X Wave Desktop",
    "Wave Desktop",
  ];

  const RESTRICTED_COLOURS = [
    "Black",
    "Dark Grey",
    "Maple",
    "Golden Maple",
    "Slate Dark Grey",
    "Midnight Black",
  ];

  const RESTRICTED_SIZES = [
    "160x80",
    "180x80",
    "160x80cm",
    "180x80cm",
    "160x80 + 60x80",
    "180x80 + 60x80",
    "160x80cm + 60x80",
    "180x80cm + 60x80",
  ];

  function isCustomTopBaseAccessory(name) {
    const n = (name || "").toLowerCase();
    return CUSTOM_TOP_LEAD_TIME_BASE_NAMES.some((base) =>
      n.includes(base.toLowerCase())
    );
  }

  function isDesktopRestricted(mainItem) {
    const deskTopSize =
      mainItem.options_with_values?.find(
        (o) => o.name === "Desk Top Size(cm)"
      )?.value || "";

    const deskTopColour =
      mainItem.options_with_values?.find(
        (o) => o.name === "Desk Top Colour"
      )?.value || "";

    return (
      RESTRICTED_SIZES.includes(deskTopSize) &&
      RESTRICTED_COLOURS.includes(deskTopColour)
    );
  }
  function isAirflowRestricted(mainItem) {
    const handle = (mainItem.handle || "").toLowerCase();
    const isAirflowProduct = handle.includes("airflow-ergonomic-task-chair");

    if (!isAirflowProduct) return false;

    const colour =
      mainItem.options_with_values?.find(
        (o) => o.name === "Colour" || o.name === "Color"
      )?.value || "";

    return colour.trim().toLowerCase() === "black";
  }

  function anyRemainingAccessoryNeedsLeadTime(variantNames) {
    return variantNames.some((name) =>
      LEAD_TIME_ACCESSORIES.some((acc) =>
        (name || "").toLowerCase().includes(acc.toLowerCase())
      )
    );
  }

  /* =====================================
    ORDER VALUE (£15000+) DELIVERY CARD HELPERS
    Mirrors the PDP's £15000+ order-value card logic
    (yy_delivery_option-new.js), but for the cart page/drawer: if the
    subtotal for a main item's group (itself + its accessories, scaled
    by quantity, excluding the delivery line) drops below the
    threshold while the Order Value card is the active delivery
    selection, it must be swapped back to the normal default.
  ===================================== */
  const ORDER_VALUE_THRESHOLD = 15000;

  function isOrderValueName(name) {
    const n = (name || "").toLowerCase();
    return n.includes("order value") && n.includes("15000");
  }

  function isDeliveryLineName(name) {
    const n = (name || "").toLowerCase();
    return n.includes("delivery") || n.includes("installation") || isOrderValueName(n);
  }

  /**
   * Sums the live cart total for everything in a main item's accessory
   * group EXCEPT the delivery/installation/order-value line itself.
   * line_price on each cart item is already price × quantity, so
   * quantity changes are automatically reflected — no separate
   * multiplication needed. Returns pounds (not pence).
   */
  function computeOrderValueTotal(cartData, accessoryGroupId) {
    return (
      cartData.items
        .filter(
          (i) =>
            i.properties && i.properties._accessoryGroupId === accessoryGroupId
        )
        .filter((i) => !isDeliveryLineName(i.variant_title || i.product_title))
        .reduce((sum, i) => sum + (i.line_price || 0), 0) / 100
    );
  }

  /**
   * Works out the "normal" (non lead-time, non order-value) default
   * delivery option for a product, respecting whatever delivery cards
   * are actually configured on that product (via
   * getAvailableDeliveryCards). The Order Value £15000+ card is always
   * excluded from consideration here — it must only ever be selected
   * via the explicit threshold check, never picked as a generic
   * "default"/"first available" fallback.
   */
  async function resolveDefaultDelivery(mainItem) {
    const mainProductPrice = parseFloat(mainItem.price || 0) / 100;

    let desiredVariantId = "57642286317955"; // FREE Delivery
    let desiredName = "Delivery Options : FREE Delivery";
    let desiredProductId = "15839611978115";
    let desiredPrice = "0";

    if (mainProductPrice <= 75) {
      desiredVariantId = "58006245278083"; // STANDARD Delivery
      desiredName = "Delivery Options : Standard Delivery";
      desiredPrice = "9.95";
    } else if (isAirflowRestricted(mainItem)) {
      desiredVariantId = "62695256850819";
      desiredName = "FREE Delivery (3 week lead time)";
      desiredPrice = "0";
    }

    let finalVariantId = desiredVariantId;
    let finalName = desiredName;
    let finalProductId = desiredProductId;
    let finalPrice = desiredPrice;

    const availableCards = (await getAvailableDeliveryCards(mainItem.handle)).filter(
      (c) => !isOrderValueName(c.name)
    );

    if (availableCards.length) {
      const matchedCard = availableCards.find(
        (c) => String(c.variantId) === String(desiredVariantId)
      );

      const chosenCard =
        matchedCard ||
        availableCards.find((c) => Number(c.price) === 0) ||
        availableCards[0];

      finalVariantId = chosenCard.variantId;
      finalName = chosenCard.name || desiredName;
      finalProductId = chosenCard.productId || desiredProductId;
      finalPrice = chosenCard.price || desiredPrice;
    }

    return {
      variantId: finalVariantId,
      name: finalName,
      productId: finalProductId,
      price: finalPrice,
    };
  }

  /**
   * Works out the delivery option that SHOULD apply after a delivery
   * sub-item itself is removed — honouring the restriction rules (desk
   * size/colour combo, remaining lead-time accessories) the same way
   * the PDP does. The Order Value £15000+ card is always excluded here
   * too — removing/replacing a delivery line never re-selects it; that
   * only ever happens via the explicit threshold check on the PDP
   * itself. Read-only (besides the GET to fetch delivery cards) — does
   * not touch the cart. Returns the variant/name/product/price to use,
   * so the caller can add it in one place.
   */
  // async function resolveReplacementDelivery(mainItem, remainingVariantNames) {
  async function resolveReplacementDelivery(mainItem, remainingVariantNames, variantNameToRemove = "") {
    const mainProductPrice = parseFloat(mainItem.price || 0) / 100;

    let desiredVariantId = "57642286317955"; // FREE Delivery
    let desiredName = "Delivery Options : FREE Delivery";
    let desiredProductId = "15839611978115";
    let desiredPrice = "0";

      if (mainProductPrice <= 75) {
      desiredVariantId = "58006245278083"; // STANDARD Delivery
      desiredName = "Delivery Options : Standard Delivery";
      desiredPrice = "9.95";
    } else if (isAirflowRestricted(mainItem)) {
      desiredVariantId = "62695256850819";
      desiredName = "FREE Delivery (3 week lead time)";
      desiredPrice = "0";
    } else {
      const desktopRestricted = isDesktopRestricted(mainItem);
      const accessoryBasedRestricted = anyRemainingAccessoryNeedsLeadTime(
        remainingVariantNames
      );

      if (desktopRestricted || accessoryBasedRestricted) {
        desiredVariantId = "58097161961859";
        desiredName = "FREE Delivery (4 week lead time)";
        desiredPrice = "0";
      }
    }

    let finalVariantId = desiredVariantId;
    let finalName = desiredName;
    let finalProductId = desiredProductId;
    let finalPrice = desiredPrice;

    const availableCards = (await getAvailableDeliveryCards(mainItem.handle)).filter(
      (c) => !isOrderValueName(c.name)
    );

    // if (availableCards.length) {
    //   const matchedCard = availableCards.find(
    //     (c) => String(c.variantId) === String(desiredVariantId)
    //   );
    //   const chosenCard =
    //     matchedCard ||
    //     availableCards.find((c) => Number(c.price) === 0) ||
    //     availableCards[0];

    //   finalVariantId = chosenCard.variantId;
    //   finalName = chosenCard.name || desiredName;
    //   finalProductId = chosenCard.productId || desiredProductId;
    //   finalPrice = chosenCard.price || desiredPrice;
    // }
        if (availableCards.length) {
      const removedCarePlusFourWeek =
        /care\+/i.test(variantNameToRemove) &&
        /installation/i.test(variantNameToRemove) &&
        /4\s*week/i.test(variantNameToRemove);

      const preferredReplacementCard = removedCarePlusFourWeek
        ? availableCards.find((c) => {
            const name = (c.name || "").toLowerCase();
            return (
              name.includes("expert installation") &&
              /4\s*week/.test(name)
            );
          })
        : null;

      console.log("[YY Delivery Replacement - Cart Page]", {
        removedDelivery: variantNameToRemove,
        carePlusFourWeekRemoved: removedCarePlusFourWeek,
        replacementSelected: (preferredReplacementCard || {}).name || "fallback",
      });

      const matchedCard = availableCards.find(
        (c) => String(c.variantId) === String(desiredVariantId)
      );

      const chosenCard =
        preferredReplacementCard ||
        matchedCard ||
        availableCards.find((c) => Number(c.price) === 0) ||
        availableCards[0];

      finalVariantId = chosenCard.variantId;
      finalName = chosenCard.name || desiredName;
      finalProductId = chosenCard.productId || desiredProductId;
      finalPrice = chosenCard.price || desiredPrice;
    }

    return {
      variantId: finalVariantId,
      name: finalName,
      productId: finalProductId,
      price: finalPrice,
    };
  }

  /**
   * If removing a Custom Top accessory means the cart no longer needs
   * the 4-week lead time delivery (desktop combo isn't restricted AND
   * no other lead-time accessory remains), this works out the swap back
   * to the normal default delivery option.
   *
   * IMPORTANT: this is now a PURE computation (plus one read-only GET
   * to fetch available delivery cards) — it does NOT touch the cart
   * itself. It mutates the local variantNames/variantIds/productIds/
   * prices arrays (so mainItem.properties can be persisted correctly)
   * and returns which stale delivery/installation cart lines need to
   * be removed and what should be added in their place. The caller is
   * responsible for actually performing those cart writes, in one
   * atomic bulk removal followed by one add — see removeCartItem().
   *
   * FIX HISTORY: this used to fire its own /cart/change.js (remove) and
   * /cart/add.js (add) calls directly, one old-delivery-item at a time,
   * without checking response.ok. On the cart page one of those removal
   * calls could silently fail while the "add new delivery" call still
   * went through, leaving BOTH the stale 4-week line and the new line
   * in the cart. Removal is now folded into a single bulk
   * /cart/update.js call in removeCartItem (the same reliable pattern
   * already used elsewhere in this file for multi-item removal), and
   * every response is checked.
   */
  async function computeLeadTimeDowngrade({
    cartData,
    mainItem,
    accessoryGroupId,
    variantNames,
    variantIds,
    productIds,
    prices,
  }) {
    if (isDesktopRestricted(mainItem)) return null;
    if (anyRemainingAccessoryNeedsLeadTime(variantNames)) return null;

    const deliveryIndex = variantNames.findIndex((n) => isDeliveryLineName(n));

    if (deliveryIndex === -1) return null;

    const currentDeliveryName = (variantNames[deliveryIndex] || "").toLowerCase();
    if (!currentDeliveryName.includes("4 week")) return null; // not on lead-time, nothing to do

    // Find EVERY existing delivery/installation sub-item in this group
    // by title rather than trusting a single stored variant_id — this
    // can't leave a stale 4-week line behind even if that id has drifted.
    const staleDeliveryItems = cartData.items.filter(
      (i) =>
        i.properties &&
        !i.properties._accessoryVariantIds &&
        i.properties._accessoryGroupId === accessoryGroupId &&
        isDeliveryLineName(i.variant_title || i.product_title)
    );

    const newDelivery = await resolveDefaultDelivery(mainItem);

    // Swap the entry in the accessory property lists
    variantNames[deliveryIndex] = newDelivery.name;
    variantIds[deliveryIndex] = newDelivery.variantId;
    productIds[deliveryIndex] = newDelivery.productId;
    prices[deliveryIndex] = newDelivery.price;

    console.log(
      "Downgrading delivery from 4-week lead time to:",
      newDelivery.variantId,
      "— removing stale line(s):",
      staleDeliveryItems.map((i) => i.key)
    );

    return { staleDeliveryItems, newDelivery };
  }

  /**
   * If the currently-selected delivery line is the "Order Value £15000
   * or above" card, and the live order subtotal for this group
   * (accessories + quantity, excluding the delivery line itself) has
   * dropped below £15000 — whether from removing an accessory,
   * reducing quantity, or any other change — this works out the swap
   * back to the normal default delivery option (Free/Standard, or the
   * 4-week lead time card if that restriction still applies).
   *
   * Pure computation (plus one read-only GET for available delivery
   * cards) — does NOT touch the cart itself. Mutates the local
   * variantNames/variantIds/productIds/prices arrays and returns which
   * stale delivery cart line(s) need removing and what to add in their
   * place, mirroring computeLeadTimeDowngrade()'s contract so callers
   * can handle both the same way.
   */
  async function computeOrderValueDowngrade({
    cartData,
    mainItem,
    accessoryGroupId,
    variantNames,
    variantIds,
    productIds,
    prices,
  }) {
    const deliveryIndex = variantNames.findIndex((n) => isDeliveryLineName(n));
    if (deliveryIndex === -1) return null;

    if (!isOrderValueName(variantNames[deliveryIndex])) return null; // not on the Order Value card, nothing to do

    const total = computeOrderValueTotal(cartData, accessoryGroupId);
    if (total >= ORDER_VALUE_THRESHOLD) return null; // still eligible, leave it alone

    const staleDeliveryItems = cartData.items.filter(
      (i) =>
        i.properties &&
        !i.properties._accessoryVariantIds &&
        i.properties._accessoryGroupId === accessoryGroupId &&
        isDeliveryLineName(i.variant_title || i.product_title)
    );

    const remainingVariantNames = variantNames.filter((_, i) => i !== deliveryIndex);
    const newDelivery = await resolveReplacementDelivery(mainItem, remainingVariantNames);

    variantNames[deliveryIndex] = newDelivery.name;
    variantIds[deliveryIndex] = newDelivery.variantId;
    productIds[deliveryIndex] = newDelivery.productId;
    prices[deliveryIndex] = newDelivery.price;

    console.log(
      "Order subtotal dropped below £15000 — downgrading delivery from Order Value card to:",
      newDelivery.variantId,
      "— removing stale line(s):",
      staleDeliveryItems.map((i) => i.key)
    );

    return { staleDeliveryItems, newDelivery };
  }

  /**
   * HIDE/SHOW DELIVERY REMOVE ICONS
   * The remove icon should only be hidden on whichever delivery card is
   * the FIRST/default one for that specific product's metafield (e.g.
   * Free Delivery for desks, but Standard Delivery for a sub-£75
   * accessory) — not based on price or title text, since that differs
   * per product. This checks the real card order fetched from the
   * product page and toggles the icon accordingly, overriding whatever
   * the Liquid template guessed on first render. Same logic as
   * cart-drawer.js, but targets .cart-included-remove on the cart page.
   */
  async function updateDeliveryRemoveButtons() {
    const cartDataJson = document.getElementById("cart_data_json");
    const cartData = cartDataJson ? JSON.parse(cartDataJson.textContent) : null;
    if (!cartData || !cartData.items) return;

    const mainItems = cartData.items.filter(
      (i) => i.properties && i.properties._accessoryVariantIds
    );

    for (const mainItem of mainItems) {
      const groupId = mainItem.properties._accessoryGroupId;

      const deliverySubItem = cartData.items.find(
        (i) =>
          i.properties &&
          !i.properties._accessoryVariantIds &&
          i.properties._accessoryGroupId === groupId &&
          isDeliveryLineName(i.variant_title || i.product_title)
      );

      if (!deliverySubItem) continue;

      const availableCards = await getAvailableDeliveryCards(mainItem.handle);
      if (!availableCards.length) continue;

      const firstCardVariantId = availableCards[0].variantId;
      const isDefaultCard =
        String(deliverySubItem.variant_id) === String(firstCardVariantId);

      const removeEl = document.querySelector(
        `.cart-included-remove[data-key="${deliverySubItem.key}"]`
      );

      if (removeEl) {
        removeEl.style.display = isDefaultCard ? "none" : "";
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateDeliveryRemoveButtons();
  });

  /**
   * FINAL SAFETY NET — runs right after a new delivery line is added.
   *
   * Everything above (computeLeadTimeDowngrade, computeOrderValueDowngrade,
   * resolveReplacementDelivery, the bulk /cart/update.js removal) works off
   * `cartData`, a SNAPSHOT of the cart taken once from the `cart_data_json`
   * script tag at page load (or a fresh /cart.js fetch for the quantity-change
   * path). If that snapshot is even slightly out of date by the time these
   * fetches fire, the "find the stale delivery line to remove" lookup can come
   * back empty — so nothing gets removed — while the "add the new delivery
   * line" step (which doesn't depend on that snapshot at all) still always
   * succeeds. That mismatch is exactly the "adds FREE Delivery but the old
   * line is still there" symptom.
   *
   * This function trusts nothing cached: it fetches the LIVE cart via
   * /cart.js right at this moment, finds every delivery/installation/order
   * value line still in this accessory group, and removes every one of them
   * except the variant we just added. Whatever happened earlier, the cart is
   * guaranteed to end up with exactly one delivery line per group.
   */
  async function cleanupDuplicateDeliveryLines(accessoryGroupId, keepVariantId) {
    try {
      const liveCart = await fetch("/cart.js").then((r) => r.json());
      if (!liveCart || !liveCart.items) return;

      const deliveryLines = liveCart.items.filter(
        (i) =>
          i.properties &&
          !i.properties._accessoryVariantIds &&
          i.properties._accessoryGroupId === accessoryGroupId &&
          isDeliveryLineName(i.variant_title || i.product_title)
      );

      if (deliveryLines.length <= 1) return; // nothing to clean up

      const linesToRemove = deliveryLines.filter(
        (i) => String(i.variant_id) !== String(keepVariantId)
      );

      if (!linesToRemove.length) return;

      console.log(
        "Cleanup: removing duplicate delivery line(s):",
        linesToRemove.map((i) => i.key)
      );

      const cleanupFormData = new FormData();
      linesToRemove.forEach((i) =>
        cleanupFormData.append(`updates[${i.key}]`, 0)
      );

      const cleanupResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: cleanupFormData,
      });

      if (!cleanupResponse.ok) {
        console.error(
          "Cart cleanup failed:",
          cleanupResponse.status,
          await cleanupResponse.text().catch(() => "")
        );
      }
    } catch (err) {
      console.error("Cleanup error:", err);
    }
  }

  /**
   * Runs after a quantity change on the cart page. Fetches the live
   * cart, checks whether the group's delivery line is the Order Value
   * £15000+ card, and if the new (quantity-scaled) subtotal has dropped
   * below threshold, swaps it back to the normal default delivery
   * before the page reloads — otherwise the reload would just show a
   * stale, no-longer-eligible Order Value card still selected.
   */
  async function enforceOrderValueAfterQuantityChange(mainItemKey, accessoryGroupId) {
    try {
      const liveCart = await fetch("/cart.js").then((r) => r.json());
      if (!liveCart || !liveCart.items) return;

      const mainItem = liveCart.items.find((i) => i.key === mainItemKey);
      if (
        !mainItem ||
        !mainItem.properties ||
        !mainItem.properties._accessoryVariantNames
      ) {
        return;
      }

      const variantNames = mainItem.properties._accessoryVariantNames.split(",");
      const variantIds = mainItem.properties._accessoryVariantIds.split(",");
      const productIds = mainItem.properties._accessoryProductIds.split(",");
      const prices = mainItem.properties._accessoryVariantPrices.split(",");

      const downgrade = await computeOrderValueDowngrade({
        cartData: liveCart,
        mainItem,
        accessoryGroupId,
        variantNames,
        variantIds,
        productIds,
        prices,
      });

      if (!downgrade) return;

      // 1) Remove the stale Order Value delivery line
      const removeFormData = new FormData();
      downgrade.staleDeliveryItems.forEach((i) =>
        removeFormData.append(`updates[${i.key}]`, 0)
      );

      const removeResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: removeFormData,
      });

      if (!removeResponse.ok) {
        console.error(
          "Order value downgrade (remove) failed:",
          removeResponse.status,
          await removeResponse.text().catch(() => "")
        );
      }

      // 2) Add the replacement default delivery line — quantity follows the
      //    LIMITED rule (1 for parent qty 1-3, 2 for parent qty > 3) when the
      //    parent is a limited product, otherwise the main item's quantity.
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: downgrade.newDelivery.variantId,
          quantity: getAccessoryQuantity(
            mainItem.product_id,
            mainItem.quantity,
            downgrade.newDelivery.variantId,
            true
          ),
          properties: { _accessoryGroupId: accessoryGroupId },
        }),
      });

      if (!addResponse.ok) {
        console.error(
          "Order value downgrade (add) failed:",
          addResponse.status,
          await addResponse.text().catch(() => "")
        );
      }

      await cleanupDuplicateDeliveryLines(accessoryGroupId, downgrade.newDelivery.variantId);

      // 3) Persist the updated accessory properties back onto the main item.
      //    quantity is always included here too — omitting it on
      //    /cart/change.js can reset the line's quantity instead of
      //    leaving it as-is.
      mainItem.properties._accessoryVariantNames = variantNames.join(",");
      mainItem.properties._accessoryVariantIds = variantIds.join(",");
      mainItem.properties._accessoryProductIds = productIds.join(",");
      mainItem.properties._accessoryVariantPrices = prices.join(",");

      const propsResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: mainItem.key,
          quantity: mainItem.quantity,
          properties: mainItem.properties,
        }),
      });

      if (!propsResponse.ok) {
        console.error(
          "Order value downgrade (properties) failed:",
          propsResponse.status,
          await propsResponse.text().catch(() => "")
        );
      }
    } catch (err) {
      console.error("Order value enforcement (quantity change) error:", err);
    }
  }

  async function removeCartItem(e, key) {
    e.preventDefault();

    const pageLoader = document.getElementById('page_Loader');

    try {
      const cartDataJson = document.getElementById("cart_data_json");
      let cartData = cartDataJson ? JSON.parse(cartDataJson.textContent) : null;

      if (!cartData || !cartData.items) return;
      if (pageLoader) {
        pageLoader.classList.add('open');
      }

      let subItemsToRemove = [];
      let mainItem = null;
      // Replacement delivery line to add AFTER removal is confirmed —
      // either from removing the delivery line itself, a Custom-Top-
      // triggered lead-time downgrade, or an order-value threshold
      // downgrade. Only ever one of these fires per click, so a single
      // slot is enough.
      let deliveryToAdd = null;

      const currentItem = cartData?.items?.find((item) => item.key === key);
      if (!currentItem) return;

      const accessoryGroupId = currentItem?.properties?._accessoryGroupId;

      const isMainProduct =
        currentItem.properties && currentItem.properties._accessoryVariantIds;

      // Every line item key that needs to be zeroed out. Always starts
      // with the clicked item itself. Everything gets removed together
      // in ONE bulk /cart/update.js call below — main-product sub items
      // AND any stale delivery/lead-time/order-value lines from a
      // downgrade — so a partial failure of one individual request
      // can't leave the cart half-updated (e.g. new delivery added but
      // old line still sitting there).
      const keysToRemove = [key];

      if (isMainProduct) {
        // Removing the MAIN product -> remove all its accessory/sub items too
        subItemsToRemove = cartData.items.filter(
          (item) =>
            item.key !== key &&
            item.properties &&
            !item.properties._accessoryVariantIds &&
            item.properties._accessoryGroupId === accessoryGroupId
        );
        subItemsToRemove.forEach((item) => keysToRemove.push(item.key));
      } else {
        // Removing a SUB item (accessory or delivery option)
        mainItem = cartData.items.find(
          (item) =>
            item.properties &&
            item.properties._accessoryGroupId === accessoryGroupId &&
            item.properties._accessoryVariantNames
        );

        if (mainItem) {
          const variantId = String(currentItem.variant_id);
          const productId = String(currentItem.product_id);
          const variantPrice = String(currentItem.line_price);

          let variantNames = mainItem.properties._accessoryVariantNames.split(",");
          let variantIds = mainItem.properties._accessoryVariantIds.split(",");
          let productIds = mainItem.properties._accessoryProductIds.split(",");
          let prices = mainItem.properties._accessoryVariantPrices.split(",");

          const removeIndex = variantIds.findIndex(
            (id, i) =>
              id === variantId ||
              productIds[i] === productId ||
              prices[i] === variantPrice
          );

          if (removeIndex !== -1) {
            const variantNameToRemove = variantNames[removeIndex];

            // Recognises Free/Standard/Saturday/AM Delivery, Installation
            // options, AND the "Order Value £15000 or above" card — that
            // last one doesn't contain the word "delivery" or
            // "installation" in its title, so it was previously being
            // missed here entirely, which meant removing it never
            // triggered adding a replacement delivery line.
            const isDeliveryOption = isDeliveryLineName(variantNameToRemove);

            // Drop the removed entry from the accessory lists first
            variantNames.splice(removeIndex, 1);
            variantIds.splice(removeIndex, 1);
            productIds.splice(removeIndex, 1);
            prices.splice(removeIndex, 1);

            if (isDeliveryOption) {
              // The delivery line itself was removed — work out what
              // should replace it (respecting restriction rules, and
              // never re-selecting the Order Value card here), and
              // queue it to be added AFTER the bulk removal below.
              // const finalDelivery = await resolveReplacementDelivery(
              //   mainItem,
              //   variantNames
              // );
              const finalDelivery = await resolveReplacementDelivery(
                mainItem,
                variantNames,
                variantNameToRemove
              );
              variantNames.push(finalDelivery.name);
              variantIds.push(finalDelivery.variantId);
              productIds.push(finalDelivery.productId);
              prices.push(finalDelivery.price);

              // Replacement delivery quantity follows the LIMITED rule
              // (parent qty 1-3 -> 1, parent qty > 3 -> 2) for limited
              // parents, otherwise the main item's quantity.
              deliveryToAdd = {
                id: finalDelivery.variantId,
                quantity: getAccessoryQuantity(
                  mainItem.product_id,
                  mainItem.quantity,
                  finalDelivery.variantId,
                  true
                ),
                properties: { _accessoryGroupId: accessoryGroupId },
              };
            } else if (isCustomTopBaseAccessory(variantNameToRemove)) {
              // Removed a Custom Top accessory (Deluxe Ply Edge / Scallop
              // Top / Wave Desktop) rather than the delivery line itself.
              // If that accessory was the only reason the cart was on the
              // 4-week lead time delivery, and the desktop size/colour
              // combo isn't independently restricted, swap the delivery
              // back to the normal default (Free/Standard).
              const downgrade = await computeLeadTimeDowngrade({
                cartData,
                mainItem,
                accessoryGroupId,
                variantNames,
                variantIds,
                productIds,
                prices,
              });

              if (downgrade) {
                downgrade.staleDeliveryItems.forEach((item) =>
                  keysToRemove.push(item.key)
                );
                deliveryToAdd = {
                  id: downgrade.newDelivery.variantId,
                  quantity: getAccessoryQuantity(
                    mainItem.product_id,
                    mainItem.quantity,
                    downgrade.newDelivery.variantId,
                    true
                  ),
                  properties: { _accessoryGroupId: accessoryGroupId },
                };
              }
            }

            // Whatever branch ran above (or didn't), the removal we just
            // made could also have dropped the order subtotal below the
            // £15000 threshold. If the group's delivery line is still
            // (or has just become) the Order Value card and the subtotal
            // no longer qualifies, downgrade it too. If a delivery swap
            // was already queued above it'll already be a non-Order-Value
            // card at this point, so this is a safe no-op in that case.
            if (!deliveryToAdd) {
              const orderValueDowngrade = await computeOrderValueDowngrade({
                cartData,
                mainItem,
                accessoryGroupId,
                variantNames,
                variantIds,
                productIds,
                prices,
              });

              if (orderValueDowngrade) {
                orderValueDowngrade.staleDeliveryItems.forEach((item) =>
                  keysToRemove.push(item.key)
                );
                deliveryToAdd = {
                  id: orderValueDowngrade.newDelivery.variantId,
                  quantity: getAccessoryQuantity(
                    mainItem.product_id,
                    mainItem.quantity,
                    orderValueDowngrade.newDelivery.variantId,
                    true
                  ),
                  properties: { _accessoryGroupId: accessoryGroupId },
                };
              }
            }

            if (variantNameToRemove in mainItem.properties) {
              mainItem.properties[variantNameToRemove] = "";
            }

            mainItem.properties._accessoryVariantNames = variantNames.join(",");
            mainItem.properties._accessoryVariantIds = variantIds.join(",");
            mainItem.properties._accessoryProductIds = productIds.join(",");
            mainItem.properties._accessoryVariantPrices = prices.join(",");
          }
        }
      }

      // 1) Remove every stale line in ONE atomic bulk call — the clicked
      //    item, any main-product sub items, and any stale
      //    delivery/lead-time/order-value line(s) from a downgrade.
      const removeFormData = new FormData();
      keysToRemove.forEach((k) => removeFormData.append(`updates[${k}]`, 0));

      const removeResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: removeFormData,
      });

      if (!removeResponse.ok) {
        console.error(
          "Cart update (remove) failed:",
          removeResponse.status,
          await removeResponse.text().catch(() => "")
        );
      }

      // 2) Only once removal is confirmed, add the replacement delivery
      //    line (if one is needed).
      if (deliveryToAdd) {
        console.log("Adding delivery variant:", deliveryToAdd.id);

        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: deliveryToAdd.id,
            quantity: deliveryToAdd.quantity || 1,
            properties: deliveryToAdd.properties,
          }),
        });

        if (!addResponse.ok) {
          console.error(
            "Cart add (delivery) failed:",
            addResponse.status,
            await addResponse.text().catch(() => "")
          );
        }

        // Belt-and-suspenders: check the LIVE cart and remove any other
        // delivery/installation/order-value line still sitting in this
        // group, so a stale line can never survive regardless of what
        // happened above.
        await cleanupDuplicateDeliveryLines(accessoryGroupId, deliveryToAdd.id);
      }

      // 3) Persist the updated accessory properties back onto the main item.
      //    IMPORTANT: quantity must always be included here. /cart/change.js
      //    with only "properties" (no "quantity") can reset the line back to
      //    its default quantity instead of leaving it untouched — this was
      //    the cause of the main product's own quantity dropping to 1 after
      //    removing a sub item.
      if (mainItem) {
        const propsResponse = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: mainItem.key,
            quantity: mainItem.quantity,
            properties: mainItem.properties,
          }),
        });

        if (!propsResponse.ok) {
          console.error(
            "Cart change (properties) failed:",
            propsResponse.status,
            await propsResponse.text().catch(() => "")
          );
        }
      }

    } catch (err) {
      console.error("Remove error:", err);
    } finally {
      console.log("Remove complete");
      if (pageLoader) {
        pageLoader.classList.remove('open');
      }
      window.location.href = "/cart";
      console.log("Redirecting...");
    }
  }

// Delivery  card Quantity in cart 
  
const LIMITED_VARIANT_IDS = [
  57642286350723,
  57642264199555,
  58097161994627,
  58097162027395,
  58006245278083,
  57642286317955,
  58315118510467,
  57897585672579,
  57897585705347,
  57897585738115,
  62695256850819,
  62695256883587,
  62695256916355,
  62683693547907,
  62306697642371,
  62306798502275,
  62306794963331,
  62448224502147,
  62448224534915,
  62448224567683,
  58097161961859, 
];

const LIMITED_PARENT_PRODUCT_IDS = [
  7011044720738,
  6964149387362,
  6893008224354,
  7051912773730,
  7011126018146,
  7052130156642,
  7011029581922,
];

function isLimitedParentProduct(productId) {
  return LIMITED_PARENT_PRODUCT_IDS.includes(Number(productId));
}

function isLimitedVariant(variantId) {
  return LIMITED_VARIANT_IDS.includes(Number(variantId));
}

function getAccessoryQuantity(parentProductId, parentQty, variantId, isDelivery) {
  if (isLimitedParentProduct(parentProductId)) {
    if (isLimitedVariant(variantId) || isDelivery) {
      // return parentQty > 3 ? 2 : 1;
      return Math.ceil(parentQty / 3);
    }
    return parentQty;
  }

  // Parent NOT in the list -> old rule (limited variant is always 1)
  if (isLimitedVariant(variantId)) return 1;

  return parentQty;
}

function limitedVariantFmt(c) {
  return '£' + (c / 100).toFixed(2);
}

function limitedVariantRefreshUI(cart) {
  const keys = cart.items.map((i) => i.key);

  document.querySelectorAll('.cart-included-remove[data-key]').forEach((el) => {
    if (!keys.includes(el.getAttribute('data-key'))) {
      const row = el.closest('.cart-included-row');
      if (row) row.remove();
    }
  });

  cart.items.forEach((i) => {
    console.log('🛒 CART ITEM:', {
      variant_id: i.variant_id,
      product_id: i.product_id,
      quantity: i.quantity,
      title: i.product_title,
      variant_title: i.variant_title
    });
    const input = document.querySelector(`input.qty[data-id="${i.key}"]`);
    if (!input) return;
    input.value = i.quantity;
    const info = input.closest('.js-cart-item-info-container');
    if (info) {
      info.querySelectorAll('.cart-item-price').forEach((el) => {
        el.textContent = limitedVariantFmt(i.final_line_price);
      });
    }
  });

  const total = document.querySelector('.summary-total span:last-child');
  if (total) total.textContent = limitedVariantFmt(cart.total_price);
}
// ✅ ADD THIS BLOCK — must be before enforceLimitedVariant
function isDeliveryLineName(name) {
  if (!name) return false;
  const n = name.toLowerCase();
  return (
    n.includes('delivery') ||
    n.includes('installation') ||
    n.includes('care+')
  );
}

function enforceLimitedVariant() {
fetch('/cart.js', { credentials: 'same-origin' })
.then((r) => r.json())
.then((cart) => {
const updates = {};
const seen = {};

  // Track delivery/limited variant lines already handled
  // within each accessory group.
  const seenDeliveryKeys = {};

  cart.items.forEach((i) => {
    const props = i.properties || {};
    const isParentLine = !!props._accessoryVariantIds;

    const parentItem =
      !isParentLine && props._accessoryGroupId
        ? cart.items.find(
            (p) =>
              p.properties &&
              p.properties._accessoryGroupId === props._accessoryGroupId &&
              p.properties._accessoryVariantIds
          )
        : null;

    // LIMITED parent product rule
    if (parentItem && isLimitedParentProduct(parentItem.product_id)) {
      const isDelivery = isDeliveryLineName(
        i.variant_title || i.product_title
      );

      // Only LIMITED_VARIANT_IDS or delivery lines are controlled
      if (!isLimitedVariant(i.variant_id) && !isDelivery) return;

      const groupKey = `${props._accessoryGroupId}:${i.variant_id}`;

      // If the same variant already exists in this group,
      // remove the duplicate line.
      if (seenDeliveryKeys[groupKey]) {
        updates[i.key] = 0;
        return;
      }

      seenDeliveryKeys[groupKey] = true;

      // Every 3 parent products = 1 delivery quantity
      //
      // 1-3   parent qty -> 1 delivery
      // 4-6   parent qty -> 2 deliveries
      // 7-9   parent qty -> 3 deliveries
      // 10-12 parent qty -> 4 deliveries
      // 13-15 parent qty -> 5 deliveries
      //
      const desired = Math.ceil(parentItem.quantity / 3);

      if (i.quantity !== desired) {
        updates[i.key] = desired;
      }

      return;
    }

    // OLD rule for products that are NOT LIMITED_PARENT_PRODUCT_IDS:
    // LIMITED_VARIANT_IDS can only exist once and quantity stays 1.
    if (!isLimitedVariant(i.variant_id)) return;
    if (parentItem) return;

    const id = Number(i.variant_id);

    if (!seen[id]) {
      seen[id] = true;

      if (i.quantity > 1) {
        updates[i.key] = 1;
      }
    } else {
      // Remove duplicate LIMITED_VARIANT_IDS lines
      updates[i.key] = 0;
    }
  });

  if (!Object.keys(updates).length) return;

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).then((r) => {
    if (!r.ok) return;

    window.location.reload();
  });
})
.catch((e) => console.error('[qty-limit] failed', e));


}

